import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { LoadMore, InfiniteLoader, Toast, Dialog } from 'react-weui'
import * as relayAction from '../../actions/relays'
import RelayLectureListItem from './RelayLectureListItem'
import { WKVisible, InfiniteScroll } from '../../components'


class RelayLectureList extends React.Component {
    constructor(props) {
        super(props)
        this.primaryBtnStyle = {
            type: 'primary',
            label: '确定',
        }
        this.cancleBtnStyle = {
            type: 'default',
            label: '取消',
            onClick: () => this.onClickCancle()
        }
    }
    componentDidMount() {
        this.props.relaySetLectureKeyword(this.props.keyword || '')
        this.props.relayFetchLectureList()
    }
    handleTouchBottom() {
        this.props.relayFetchLectureList()
    }
    renderLectureList(list) {
        return list.map(lecture => {
            return (
                <RelayLectureListItem lecture={lecture} key={lecture.id} />
            )
        })
    }
    onClickCreateLiveroom () {
        this.props.relaySetLectureCheckRes({})
        window.location = `/account/modify?redirect_url=/lecture/relay_confirm_new?id=${this.props.currentLecture.id}&type=lecture`
    }
    onClickCancle () {
        this.props.relaySetLectureCheckRes({})
    }
    render() {
        const { lectureList, lectureHasMore, lectureCheckRes: checkRes, tabId } = this.props
        if (tabId !== 0) return null
        if (lectureList === null) return <LoadMore loading>正在加载</LoadMore>
        return (
            <div className='lecture-list-content'>
                {this.renderLectureList(lectureList)}
                <WKVisible className='margin-bottom' show={this.props.lectureIsAsking && lectureHasMore}>
                    <LoadMore loading>正在加载</LoadMore>
                </WKVisible>
                <WKVisible className='margin-bottom nomore-wrap' show={!lectureHasMore}>
                    <LoadMore showLine>没有更多内容了</LoadMore>
                </WKVisible>
                <Toast icon="loading" iconSize='small' show={this.props.lectureCheck}>正在检查</Toast>
                <Dialog type="ios" title='温馨提示' show={checkRes.code === 1 || checkRes.code === 2 || checkRes.code === 4 || checkRes.code === 5}
                    buttons={[{ ...this.primaryBtnStyle, onClick: () => this.onClickCancle() }]}>
                    {checkRes.msg}
                </Dialog>
                <Dialog type="ios" title='温馨提示' show={checkRes.code === 3}
                    buttons={[this.cancleBtnStyle, { ...this.primaryBtnStyle, onClick: e => this.onClickCreateLiveroom() }]}
                >   
                    {checkRes.msg}
                </Dialog>
                <InfiniteScroll 
                    onTouchBottom={() => this.handleTouchBottom()}
                    isStop={this.props.lectureIsAsking || this.props.tabId !== 0}
                    distance={100}
                />
            </div>
        )
    }
}


export default connect(state => ({
    lectureList: state.relay.lectureList,
    lectureHasMore: state.relay.lectureHasMore,
    tabId: state.component.wkTab.selectId,
    lectureCheck: state.relay.lectureCheck,
    lectureCheckRes: state.relay.lectureCheckRes,
    currentLecture: state.relay.currentLecture,
    lectureIsAsking: state.relay.lectureIsAsking,
}), dispatch => bindActionCreators({ ...relayAction }, dispatch))(RelayLectureList)


// WEBPACK FOOTER //
// ./src/components/relays/RelayLectureList.js